import i18n from '../../i18n';

export const modalStyles = {
  overlay: {
    zIndex: 10,
    backgroundColor: 'rgba(255, 255, 255, 0.98)'
  },
  content: {
    background: 'rgba(255, 255, 255, 0)',
    border: 'none',
    padding: '0',
    top: '0',
    left: '0',
    right: 'auto',
    bottom: 'auto',
    width: '100%',
    height: '100%',
    overflow: 'hidden'
  }
};


export const FILTERS = {
  ALL: 'ALL',
  BUILDINGS: 'BUILDINGS',
  SUB_REGIONS: 'SUB_REGIONS',
  REGIONS: 'REGIONS',
  STREETS: 'STREETS'
};

export const filtersPlaceholder = new Map([
  [FILTERS.ALL, [i18n.t('components.searchFullscreen.constants.all1'), i18n.t('components.searchFullscreen.constants.all1')]],
  [FILTERS.REGIONS, [i18n.t('components.searchFullscreen.constants.regions'), i18n.t('components.searchFullscreen.constants.regions')]],
  [FILTERS.SUB_REGIONS, [i18n.t('components.searchFullscreen.constants.sub_regions'), i18n.t('components.searchFullscreen.constants.sub_regions')]],
  [FILTERS.BUILDINGS, [i18n.t('components.searchFullscreen.constants.buildings'), i18n.t('components.searchFullscreen.constants.buildings')]],
  [FILTERS.STREETS, [i18n.t('components.searchFullscreen.constants.streets'), i18n.t('components.searchFullscreen.constants.streets')]]
]);



// WEBPACK FOOTER //
// ./src/components/SearchFullscreen/constants.js